import { useEffect, useRef, useState } from 'react';

/**
 * The width a chart is actually drawn at, so its viewBox can match it. A chart drawn at a fixed
 * 600 wide and scaled down to a phone's 250 scales its 11px labels down with it, to under 5px.
 * Measured, the viewBox is the box, and text stays the size it was written at on every screen.
 * Until there is a measurement (the first paint, or a test without layout) it is `fallback`.
 */
export function useChartWidth<T extends Element>(fallback = 600) {
    const ref = useRef<T>(null);
    const [width, setWidth] = useState(fallback);

    useEffect(() => {
        const node = ref.current;
        if (!node || typeof ResizeObserver === 'undefined') return;
        const observer = new ResizeObserver(([entry]) => {
            const measured = Math.round(entry?.contentRect.width ?? 0);
            if (measured > 0) setWidth(measured);
        });
        observer.observe(node);
        return () => observer.disconnect();
    }, []);

    return [ref, width] as const;
}
